import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-assistant',
  templateUrl: './assistant.component.html'
})
export class AssistantComponent {

  @Output()
  assistantDisabled: EventEmitter<void> = new EventEmitter<void>();

  disableAssistant() {
    this.assistantDisabled.emit();
  }

}
